var ConsumerPriceTool = function(text) {
	this.text = text;
	this.groups = [];
	this.events = [];
	this.updateChartTimeout = false;
	this.settings = {
		x3: 3,
	};

	/*
	Chart.defaults.font.family = 'Satoshi';
	Chart.defaults.color = "#444";
	Chart.defaults.font.size = 16;

	this.chart = new Chart(document.getElementById('consumerprice-chart'), {
		type: 'bar',
		data: {
			labels: [],
			datasets: []
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				y: {
					ticks: {
						callback: function(value) {
							return "€ " + formatNumber(value, 0)
						}
					},
					afterFit(scale) {
						scale.width = 100;
					},
				}
			},
			plugins: {
				legend: {
					display: false
				},
				tooltip: {
					callbacks: {
						label: function(context) {
							var label = context.dataset.label || '';

							if (label) {
								label = ' ' + label + ': ';
							}

							if (context.parsed.y !== null) {
								label += "€ " + formatNumber(context.parsed.y, 2);
							}

							return label;
						}
					}
				}
			}
		}
	});
 	*/

	this.on('change', () => {
		if (this.updateChartTimeout) {
			clearTimeout(this.updateChartTimeout);
		}

		this.updateChartTimeout = setTimeout(() => { this.updateChart(); }, 50);
	});
}

ConsumerPriceTool.prototype.getGroups = function() {
	return this.groups;
};

ConsumerPriceTool.prototype.getGroup = function(groupKey) {
	return this.groups[groupKey];
};

ConsumerPriceTool.prototype.getMax = function(property) {
	var values = [];

	$.each(this.groups, (groupKey, group) => {
		values[groupKey] = group.getProperty(property);
	});

	return Math.max(... values);
};

ConsumerPriceTool.prototype.getMaxGroupKey = function() {
	return Math.max(... this.groups.keys());
};

ConsumerPriceTool.prototype.getNextGroupKey = function() {
	return this.getMaxGroupKey() + 1;
};

ConsumerPriceTool.prototype.deleteGroup = function(groupKey) {
	this.groups.splice(groupKey, 1);
	this.trigger('change');
};

ConsumerPriceTool.prototype.update = function(groupKey, values) {
	var group = this.groups[groupKey];

	if (!group) {
		group = new ConsumerPriceToolData(groupKey, this);
		this.groups[groupKey] = group;
	}

	$.each(values, (field, value) => {
		group.setData(field, value);
	});

	this.trigger('change');
};

ConsumerPriceTool.prototype.updateChart = function() {
	// this.chart.data.labels = [];
	// this.chart.data.datasets = [];
	//
	// var dataset = {
	// 	label: this.text.Marge,
	// 	backgroundColor: '#CAA44F',
	// 	data: [],
	// };
	//
	// $.each(this.getData(), (group, groupData) => {
	// 	this.chart.data.labels[group] = [groupData.title, "€ " + formatNumber(groupData.Margin, 2)];
	// 	dataset.data.push(groupData.Margin);
	// });
	//
	// this.chart.data.datasets.push(dataset);
	// this.chart.update();

	// var property = 'Margin';
	var property = 'MarginPerHL';
	var max = this.getMax(property) * 1; //.1;

	$.each(this.groups, (groupKey, group) => {
		var value = group.getProperty(property);
		var perc  = 100 / max * value;

		$('.consumerpricetool .chart-bar[data-group="' + groupKey + '"] span').css('width', perc + '%');
	});
};

ConsumerPriceTool.prototype.updateSetting = function(setting, value) {
	this.settings[setting] = value;
	this.trigger('change');
};

ConsumerPriceTool.prototype.getSettings = function() {
	return this.settings;
};

ConsumerPriceTool.prototype.getData = function() {
	var data = [];

	$.each(this.groups, (groupKey, group) => {
		data[groupKey] = group.getData();
	});

	return data;
};

ConsumerPriceTool.prototype.on = function(event, callback) {
	this.events.push({
		event: event,
		callback: callback
	});
};

ConsumerPriceTool.prototype.trigger = function(event, data) {
	$.each(this.events, (key, eventSettings) => {
		if (eventSettings.event !== event) return;
		eventSettings.callback(data);
	});
};

var ConsumerPriceToolData = function(key, tool) {
	this.key = key;
	this.tool = tool;
	this.input = {
		Title: '',
		PricePerKeg: 0,
		VolumePerGlassCL: 25,
		VolumePerKegL: 50,
		CurrentConsumerPrice: 0,
		BonusManagement: 0,
		EstimatedVolumeHL: 0,
		VatRate: .21,
	};

	this.calculated = {
		PricePerL: () => {
			return this.input.VolumePerKegL > 0 ? this.input.PricePerKeg / this.input.VolumePerKegL : 0;
		},

		AveragePurchaseConsumerPrice: () => {
			return this.calculated.PricePerL() / 100 * this.input.VolumePerGlassCL;
		},

		ConsumerPriceExVat: () => {
			return this.input.CurrentConsumerPrice / (1 + this.input.VatRate);
		},

		AverageMarginPerConsumption: () => {
			return this.calculated.ConsumerPriceExVat() - this.calculated.AveragePurchaseConsumerPrice();
		},

		GrossMarginPercentage: () => {
			return this.calculated.ConsumerPriceExVat() === 0 ? 0 : this.calculated.AverageMarginPerConsumption() / this.calculated.ConsumerPriceExVat() * 100;
		},

		IndexPrice: () => {
			return this.key === 0 ? 100 : 100 / this.tool.getGroup(0).getData().PricePerL * this.calculated.PricePerL();
		},

		AveragePurchaseConsumerPriceX3: () => {
			return this.calculated.AveragePurchaseConsumerPrice() * this.tool.settings.x3;
		},

		AveragePurchaseConsumerPriceIncVatX3: () => {
			return this.calculated.AveragePurchaseConsumerPriceX3() * (1 + this.input.VatRate);
		},

		AverageMarginX3: () => {
			return this.calculated.AveragePurchaseConsumerPriceX3() / (1 + this.input.VatRate) - this.calculated.AveragePurchaseConsumerPrice();
		},

		GrossMarginX3: () => {
			return (this.calculated.AveragePurchaseConsumerPriceX3() - this.calculated.AveragePurchaseConsumerPrice()) / this.calculated.AveragePurchaseConsumerPriceX3() * 100;
		},

		MarginPerHL: () => {
			// Verschil met de XLSX: Hier wordt BonusManagement erbij opgeteld
			return this.calculated.AverageMarginPerConsumption() / this.input.VolumePerGlassCL * 100 * 100 + this.input.BonusManagement;
		},

		Margin: () => {
			// Verschil met de XLSX: Hier wordt NIET meer BonusManagement erbij opgeteld, dat gebeurt al bij MarginPerHL()
			return (this.calculated.MarginPerHL() * this.input.EstimatedVolumeHL); // + (this.input.BonusManagement * this.input.EstimatedVolumeHL);
		},
	};
};

ConsumerPriceToolData.prototype.setData = function(field, value) {
	var type = typeof this.input[field];

	if (type === 'undefined') {
		return;
	}

	if (type === 'number') {
		value = parseNumber(value);
	}

	this.input[field] = value;
};

ConsumerPriceToolData.prototype.getProperty = function(property) {
	if (this.input[property]) {
		return this.input[property];
	}

	if (this.calculated[property]) {
		return this.calculated[property]();
	}

	return null;
};

ConsumerPriceToolData.prototype.getData = function() {
	var data = this.input;

	for (const property in this.calculated) {
		data[property] = this.calculated[property]();
	}

	return data;
};
